var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPipExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19958_237562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52603 16.6667C3.01172 16.6667 2.57347 16.4866 2.21126 16.1263C1.84907 15.766 1.66797 15.3301 1.66797 14.8185V9.92962C1.66797 9.6703 1.75763 9.45146 1.93696 9.27309C2.11629 9.09471 2.33631 9.00553 2.59702 9.00553C2.85772 9.00553 3.07774 9.09471 3.25706 9.27309C3.43639 9.45146 3.52606 9.6703 3.52606 9.92962V14.8185H16.4766V5.18643H9.96223C9.70153 5.18643 9.48152 5.09724 9.30219 4.91887C9.12286 4.7405 9.0332 4.52165 9.0332 4.26234C9.0332 4.00301 9.12286 3.78416 9.30219 3.60579C9.48152 3.42743 9.70153 3.33825 9.96223 3.33825H16.4766C16.9909 3.33825 17.4291 3.51838 17.7913 3.87865C18.1535 4.23893 18.3346 4.67486 18.3346 5.18643V14.8185C18.3346 15.3301 18.1535 15.766 17.7913 16.1263C17.4291 16.4866 16.9909 16.6667 16.4766 16.6667H3.52603ZM11.708 11.3204L13.5403 13.143C13.7167 13.3184 13.9219 13.4061 14.156 13.4061C14.39 13.4061 14.5953 13.3184 14.7716 13.143C14.948 12.9675 15.0362 12.76 15.0362 12.5204C15.0362 12.2808 14.948 12.0733 14.7716 11.8979L12.9393 10.0753H14.1094C14.357 10.0753 14.5657 9.99099 14.7352 9.82234C14.9048 9.65368 14.9896 9.44616 14.9896 9.19979C14.9896 8.95343 14.9048 8.74592 14.7352 8.57725C14.5657 8.4086 14.357 8.32428 14.1094 8.32428H10.8766C10.6159 8.32428 10.3959 8.41346 10.2166 8.59184C10.0372 8.77021 9.94759 8.98905 9.94759 9.24837V12.4639C9.94759 12.7103 10.0324 12.9178 10.2019 13.0865C10.3715 13.2551 10.5801 13.3395 10.8278 13.3395C11.0755 13.3395 11.2841 13.2551 11.4536 13.0865C11.6232 12.9178 11.708 12.7103 11.708 12.4639V11.3204ZM2.597 7.38075C2.33629 7.38075 2.11627 7.29156 1.93694 7.11319C1.75761 6.93482 1.66796 6.71597 1.66797 6.45666V4.25748C1.66797 3.99816 1.75763 3.77931 1.93696 3.60093C2.11629 3.42256 2.33631 3.33337 2.59702 3.33337H6.47072C6.73142 3.33337 6.95144 3.42256 7.13076 3.60093C7.31009 3.77931 7.39976 3.99816 7.39976 4.25748V6.45666C7.39976 6.71597 7.31009 6.93482 7.13076 7.11319C6.95144 7.29156 6.73142 7.38075 6.47072 7.38075H2.597Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19958_237562",
    x: 0.667969,
    y: 3.33337,
    width: 18.668,
    height: 15.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19958_237562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19958_237562",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPipExit);
export default __webpack_public_path__ + "static/media/icon-pip-exit.e3088fd426bb289188a4b35c719172f5.svg";
export { ForwardRef as ReactComponent };